import { useMemo } from 'react'

import { isMamba } from 'common/constants'

import { useShallowEqualSelector } from './useShallowEqualSelector'

export const useMambaPartner = (): boolean => {
  const { partnerId } = useShallowEqualSelector(
    ({ systemReducer: { partnerId } }) => ({ partnerId })
  )

  return useMemo(() => isMamba(partnerId), [partnerId])
}
